import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

const FooterComponent: React.FC = ({ priceChanges,save }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '5px',
                width: '100vw',
                backgroundColor: 'white',
                boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                position: 'sticky',
                alignItems: 'center',
                justifyContent: 'space-between',
                bottom: 0,
                zIndex: 1000
            }}
        >
            {/* Total Orders */}
            <Box sx={{ fontWeight: 'bold', fontSize: '16px' }}>סה"כ שינויים: {priceChanges.length}</Box>
            <Button
                loading={false}
                disabled={false}
                sx={{ minWidth: '55vw' }}
                variant="contained"
                color="success"
                onClick={(e) => {
                    save(priceChanges);
                }}
            >
                שמור הכל
            </Button>
        </Box>
    );
};

export default FooterComponent;
